export default "__VITE_ASSET__DfqpR5SX__"